import React, { Suspense, lazy } from 'react';
import WelcomeScreen from './components/WelcomeScreen';
const Routes = lazy(() => import('./routes/routes'))

const App = () => {
  return (
    <>
      <Suspense fallback={<WelcomeScreen />}>
        <Routes />
      </Suspense>
    </>
  )
}

export default App
